export default __webpack_public_path__ + "static/media/Love05.5d3a3678.png";